/**
 * Festival week dates by year — single source for dancer travel UI,
 * lodging defaults, and related copy.
 */

import { IABF_DANCER_YEAR } from './iabf-event'

/**
 * @typedef {object} FestivalWeek
 * @property {string} arrivalIso - YYYY-MM-DD
 * @property {string} departureIso - YYYY-MM-DD
 * @property {string} arrivalWeekdayLabel - e.g. "Monday, July 12"
 * @property {string} departureWeekdayLabel
 * @property {string} checkInTimeLabel - e.g. "4:00 PM"
 * @property {string} welcomeTimeLabel
 * @property {string} breakfastTimeLabel
 * @property {string} checkoutTimeLabel
 * @property {string} defaultCheckIn - full string for admin/export
 * @property {string} defaultCheckOut
 */

/** @type {Record<number, FestivalWeek>} */
export const FESTIVAL_WEEKS = {
  2026: {
    arrivalIso: '2026-07-06',
    departureIso: '2026-07-11',
    arrivalWeekdayLabel: 'Monday, July 6',
    departureWeekdayLabel: 'Saturday, July 11',
    checkInTimeLabel: '4:00 PM',
    welcomeTimeLabel: '6:00 PM',
    breakfastTimeLabel: '7:30 AM',
    checkoutTimeLabel: '11:00 AM',
    defaultCheckIn: 'Monday, July 6, 2026 at 4 PM',
    defaultCheckOut: 'Saturday, July 11, 2026 at 11 AM'
  },
  2027: {
    arrivalIso: '2027-07-12',
    departureIso: '2027-07-17',
    arrivalWeekdayLabel: 'Monday, July 12',
    departureWeekdayLabel: 'Saturday, July 17',
    checkInTimeLabel: '4:00 PM',
    welcomeTimeLabel: '6:00 PM',
    breakfastTimeLabel: '8:00 AM',
    checkoutTimeLabel: '11:00 AM',
    defaultCheckIn: 'Monday, July 12, 2027 at 4 PM',
    defaultCheckOut: 'Saturday, July 17, 2027 at 11 AM'
  }
}

/**
 * @param {number} [year]
 * @returns {FestivalWeek}
 */
export function festivalWeek (year = IABF_DANCER_YEAR) {
  const y = Number(year) || IABF_DANCER_YEAR
  return FESTIVAL_WEEKS[y] || FESTIVAL_WEEKS[IABF_DANCER_YEAR] || FESTIVAL_WEEKS[2027]
}

const CARPOOL_MONTHS = {
  jan: 0, january: 0, feb: 1, february: 1, mar: 2, march: 2,
  apr: 3, april: 3, may: 4, jun: 5, june: 5, jul: 6, july: 6,
  aug: 7, august: 7, sep: 8, sept: 8, september: 8,
  oct: 9, october: 9, nov: 10, november: 10, dec: 11, december: 11
}

/**
 * Sort key for carpool slot labels like "Saturday, July 11" (no year in the string).
 * Uses the festival year so weekday/month/day land on that year's calendar.
 * @param {string} dateStr
 * @param {number} year
 * @returns {number}
 */
export function carpoolDateSortKey (dateStr, year) {
  const y = Number(year)
  const yearNum = Number.isFinite(y) && y > 0 ? y : IABF_DANCER_YEAR
  const s = String(dateStr || '').trim().toLowerCase()
  if (!s) {
    return Infinity
  }
  const m = s.match(/([a-z]+)\s+(\d+)/)
  if (m && CARPOOL_MONTHS[m[1]] !== undefined) {
    return new Date(yearNum, CARPOOL_MONTHS[m[1]], parseInt(m[2], 10)).getTime()
  }
  const t = Date.parse(s + ', ' + yearNum)
  return isNaN(t) ? Infinity : t
}
